import { thanos26Delete, thanos26Get, thanos26Json, thanos26Put } from "./thanos26Client";

/** TimeSafe login of the signed in user as stored by thanos26. The password is never returned. */
export interface ITimesafeLoginStatus {
    benutzername: string | null;
    hinterlegt: boolean;
    geaendert: string | null;
}

async function getTimesafeLogin(): Promise<ITimesafeLoginStatus> {
    return thanos26Json(await thanos26Get("timesafe/zugangsdaten"));
}

/**
 * Sends the TimeSafe login to thanos26. The backend checks it against TimeSafe and only stores it
 * (encrypted) when the login works; otherwise it answers 400 with a message, thrown as ApiError.
 */
async function saveTimesafeLogin(benutzername: string, passwort: string): Promise<ITimesafeLoginStatus> {
    return thanos26Json(await thanos26Put("timesafe/zugangsdaten", {}, { benutzername, passwort }));
}

async function deleteTimesafeLogin(): Promise<void> {
    await thanos26Json(await thanos26Delete("timesafe/zugangsdaten"));
}

export default { getTimesafeLogin, saveTimesafeLogin, deleteTimesafeLogin };
